const KEY = 'cv_mpd_v1';

export function readProgress() {
  try {
    const p = JSON.parse(localStorage.getItem(KEY)) || {};
    return { done: p.done || {}, checks: p.checks || {}, quiz: p.quiz || {} };
  } catch { return { done: {}, checks: {}, quiz: {} }; }
}

export function writeProgress(p) {
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch { /* quota */ }
}
